export function confirmExternalNavigation(
  event: MouseEvent,
  applicationName: string,
) {
  const confirmed = window.confirm(
    `Vous allez ouvrir ${applicationName} dans un nouvel onglet. Voulez-vous continuer ?`,
  );
  if (!confirmed) event.preventDefault();
}
